import render from './render';

export default render();
// generated at 2026/1/23 15:30:20 by sui v3.1.105